import { render } from "./BtnWhite.vue?vue&type=template&id=ec978c38&scoped=true"
import script from "./BtnWhite.vue?vue&type=script&lang=js"
export * from "./BtnWhite.vue?vue&type=script&lang=js"

import "./BtnWhite.vue?vue&type=style&index=0&id=ec978c38&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec978c38"]])

export default __exports__